import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { startedAt: String, formats: Object };

  #timer = null;

  connect() {
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnect() {
    clearInterval(this.#timer);
  }

  #tick() {
    this.element.textContent = this.#format(this.#elapsed);
  }

  get #elapsed() {
    return Math.round((Date.now() - Date.parse(this.startedAtValue)) / 1000);
  }

  #format(seconds) {
    if (seconds < 60) return this.formatsValue.seconds.replace('%{count}', seconds);

    if (seconds < 3600) {
      return this.formatsValue.minutes
        .replace('%{minutes}', Math.floor(seconds / 60))
        .replace('%{seconds}', this.#pad(seconds % 60));
    }

    return this.formatsValue.hours
      .replace('%{hours}', Math.floor(seconds / 3600))
      .replace('%{minutes}', this.#pad(Math.floor((seconds % 3600) / 60)));
  }

  #pad(value) {
    return String(value).padStart(2, '0');
  }
}
